export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-foreground-100">
      <div className="mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="font-heading font-bold text-2xl text-white mb-4 block">
              老子影视网
            </span>
            <p className="text-sm text-foreground-400 leading-relaxed">
              电视剧大全全集播放平台，提供国产剧全集、韩剧全集及最新电视剧的免费在线观看服务，
              高清画质流畅不缓冲，每日同步更新，追剧必备。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="block text-sm text-foreground-400 hover:text-white transition-colors duration-150 whitespace-nowrap cursor-pointer">热播榜单</a>
              <a href="#cards" onClick={(e) => handleNavClick(e, '#cards')} className="block text-sm text-foreground-400 hover:text-white transition-colors duration-150 whitespace-nowrap cursor-pointer">精选剧集</a>
              <a href="#updates" onClick={(e) => handleNavClick(e, '#updates')} className="block text-sm text-foreground-400 hover:text-white transition-colors duration-150 whitespace-nowrap cursor-pointer">更新快讯</a>
              <a href="#features" onClick={(e) => handleNavClick(e, '#features')} className="block text-sm text-foreground-400 hover:text-white transition-colors duration-150 whitespace-nowrap cursor-pointer">平台优势</a>
              <a href="#topics" onClick={(e) => handleNavClick(e, '#topics')} className="block text-sm text-foreground-400 hover:text-white transition-colors duration-150 whitespace-nowrap cursor-pointer">话题广场</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">内容分类</h4>
            <div className="space-y-2.5">
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="block text-sm text-foreground-400 hover:text-white transition-colors duration-150 whitespace-nowrap cursor-pointer">国产剧全集</a>
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="block text-sm text-foreground-400 hover:text-white transition-colors duration-150 whitespace-nowrap cursor-pointer">韩剧全集</a>
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="block text-sm text-foreground-400 hover:text-white transition-colors duration-150 whitespace-nowrap cursor-pointer">最新电视剧</a>
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="block text-sm text-foreground-400 hover:text-white transition-colors duration-150 whitespace-nowrap cursor-pointer">高分推荐</a>
              <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="block text-sm text-foreground-400 hover:text-white transition-colors duration-150 whitespace-nowrap cursor-pointer">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              更多优质合作伙伴即将入驻，敬请期待。
            </p>
            <div className="mt-4">
              <a
                href="#contact"
                onClick={(e) => handleNavClick(e, '#contact')}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-600 hover:bg-primary-500 text-white text-sm font-medium rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                联系我们
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800/30 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 老子影视网 laoziys.com 版权所有
          </p>
          <p className="text-xs text-foreground-600">
            本站所有内容仅供学习交流，请于下载后24小时内删除
          </p>
        </div>
      </div>
    </footer>
  );
}